import { Component, OnInit } from '@angular/core';
import { TrackingService } from './services/tracking.service';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from "./components/footer/footer.component";
import { MatIconModule } from '@angular/material/icon';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CartToastComponent } from './components/cart-toast/cart-toast.component';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, CommonModule, CartToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'beer-project-web';
  isHome:boolean = false
  showHeaderAndFooter: boolean = true;
  routesNotShowHeaderAndFooter = [
    '/coming-soon',
    '/maintenance',
    '/select-country',
    '/feedback',
  ]

  constructor(
    private router: Router,
    private trackingService: TrackingService,
    private languageService: LanguageService,
  ) {
    this.languageService.init();
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      // Track PageView on every navigation
      this.trackingService.track('PageView');

      // Scroll al inicio de la página en cada navegación
      window.scrollTo(0, 0);
      
      const currentUrl = (event as NavigationEnd).url.split('?')[0]; // Extraer la ruta base
      const redirectUrl = (event as NavigationEnd).urlAfterRedirects.split('?')[0]; // Extraer la ruta base      
      if(currentUrl == '/' ||  redirectUrl == '/'){
        this.isHome = true
      }else{
        this.isHome = false
      }

      //VERIFICA SOLO SI LA RUTA ES EXACTA
      // this.showHeaderAndFooter = !this.routesNotShowHeaderAndFooter.includes(currentUrl);
      // if (this.showHeaderAndFooter) {
      //   this.showHeaderAndFooter = !this.routesNotShowHeaderAndFooter.includes(redirectUrl);
      // }

      //VERIFICA SI LA RUTA COMIENZA CON ALGUNA DE LAS RUTAS EN LA LISTA
      this.showHeaderAndFooter = !this.routesNotShowHeaderAndFooter.some(route => 
        currentUrl === route || currentUrl.startsWith(route));
      if (this.showHeaderAndFooter) {
        this.showHeaderAndFooter = !this.routesNotShowHeaderAndFooter.some(route => 
          redirectUrl === route || redirectUrl.startsWith(route));
      }
    });
  }
}
